<template>
  <div class="d-flex flex-column">
    <NavBarWeb :showMerchantLogin="true" />
    <div class="row main-container">
        <div class="col-md-6 col-sm-12 iframe-outer-container">
          <div class="iframe-container">
            <iframe :src="merchantSignUpUrl" frameborder="0"></iframe>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 sign-up-image-outer-container">
          <img src="@/assets/images/merchant-sign-up.webp" class="sign-up-image" alt=“merchant-sign-up”>
        </div>
      </div>
    <FooterWeb />
  </div>
</template>

<script>

import NavBarWeb from "../components/NavBarWeb";
import FooterWeb from "../components/FooterWeb";

export default {
  components: {
    FooterWeb,
    NavBarWeb
  },
  data() {
    return {
      merchantSignUpUrl: process.env.VUE_APP_MERCHANT_SIGNUP_BASE_URL
    };
  }
}
</script>

<style scoped>
.main-container {
  margin-top: 4.5rem;
  padding-right: 0;
  margin-right: 0;
}

.iframe-outer-container {
  padding-right: 0;
}

.iframe-container {
  width: 100%;
  min-height: 100%;
  position: relative;
  overflow: auto;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sign-up-image-outer-container {
  padding-left: 0;
  padding-right: 0;
}

.sign-up-image {
  width: 100%;
}
</style>

